<script>
export default {
  name: 'StatusText',
  components: {},
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary'
    }
  },
  data() {
    return {

    };
  },
  computed: {

  },
  watch: {},
  mounted() {

  },
  methods: {

  }
}
</script>

<template>
  <div
    class="status-text"
    :class="type"
  >{{ value }}</div>
</template>

<style lang="scss" scoped>
.status-text {
  &.primary {
    color: var(--color-primary);
  }
  &.warning {
    color: var(--color-warning);
  }
  &.success {
    color: var(--color-success);
  }
  &.info {
    color: var(--color-info);
  }
}
</style>
